"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActivity = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
var svgs_1 = require("../assets/svgs");
var UserActivity = function (_a) {
    var userName = _a.userName, title = _a.title, message = _a.message, action = _a.action, messageType = _a.messageType;
    return ((0, jsx_runtime_1.jsxs)(_1.Stack, __assign({ direction: "row", sx: { marginLeft: '-0.4rem' } }, { children: [(0, jsx_runtime_1.jsx)(_1.ThemedAvatar, __assign({ sx: {
                    width: '5rem',
                    height: '5rem',
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    borderWidth: '0.4rem',
                    borderColor: 'common.white',
                    borderStyle: 'solid',
                    borderRadius: '3rem',
                } }, { children: userName.charAt(0).toUpperCase() })), (0, jsx_runtime_1.jsxs)(_1.Box, __assign({ sx: { paddingLeft: '2rem' } }, { children: [(0, jsx_runtime_1.jsxs)(_1.Stack, __assign({ direction: "row", sx: { alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(_1.Typography, __assign({ sx: {
                                    color: 'primary.600',
                                    fontWeight: '700',
                                } }, { children: userName })), (0, jsx_runtime_1.jsx)(_1.Typography, __assign({ sx: { paddingX: '1rem' } }, { children: '\u25CF' })), (0, jsx_runtime_1.jsx)(_1.Typography, __assign({ sx: {
                                    textTransform: 'capitalize',
                                    fontWeight: '400',
                                    fontStyle: 'normal',
                                } }, { children: title }))] })), (0, jsx_runtime_1.jsxs)(_1.Typography, __assign({ sx: {
                            paddingTop: '0.4rem',
                            fontSize: '1.4rem',
                        } }, { children: [messageType === 'info' ? ((0, jsx_runtime_1.jsx)(svgs_1.NotifcationIcon, { style: { marginRight: '0.8rem' } })) : ((0, jsx_runtime_1.jsx)(svgs_1.ElevatedIcon, { style: { marginRight: '0.8rem' } })), message, ' ', (action === null || action === void 0 ? void 0 : action.text) && (0, jsx_runtime_1.jsx)(_1.Link, __assign({ href: action === null || action === void 0 ? void 0 : action.link }, { children: action === null || action === void 0 ? void 0 : action.text })), ' '] }))] }))] })));
};
exports.UserActivity = UserActivity;
